import {
  ScheduleOutlined,
  SettingOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import {
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { useGetCurrentPractitioner } from 'src/hooks/settings';

export const useCareConnectSideMenus = () => {
  const { isEntitled: hasIntakeAccess } = useFeatureEntitlements('intake');
  const { isEntitled: hasFollowupAccess } = useFeatureEntitlements('followup');

  // Don't show appointments tab is both intake access and followup access are false
  if (!hasIntakeAccess && !hasFollowupAccess) {
    return [];
  }

  const menus = [
    {
      path: '/appointments',
      title: 'Appointments',
      icon: <ScheduleOutlined />,
    },
  ];

  return menus;
};

export const useSettingsSideMenus = () => {
  const { isSuperAdmin } = useGetCurrentPractitioner();

  const { isEntitled: isOPHqAccount } = useFeatureEntitlements('op-hq-account');
  const { isEntitled: isOPHqSuperAdmin } = usePermissionEntitlements(
    'op-hq-invite-practitioner'
  );
  const { isEntitled: isOpenDrHqAccount } =
    useFeatureEntitlements('open-dr-hq-account');
  const { isEntitled: isOpenDrHqSuperAdmin } = usePermissionEntitlements(
    'open-dr-hq-invite-practitioner'
  );
  const { isEntitled: isPhoneTriageModuleEntitled } =
    useFeatureEntitlements('phone-triage');
  const { isEntitled: hasCallReadAccess } =
    usePermissionEntitlements('calls.read');
  const { isEntitled: hasReferralsAccess } = useFeatureEntitlements('referral');

  const hasTagAccess =
    hasReferralsAccess ||
    isSuperAdmin ||
    (isPhoneTriageModuleEntitled && hasCallReadAccess);

  const settingsMenus = [
    {
      path: '/settings',
      title: 'Settings',
      icon: <SettingOutlined />,
      submenu: [
        ...(isOPHqAccount && isOPHqSuperAdmin
          ? [
              {
                path: '/op-settings',
                title: 'OP Admin',
                icon: (
                  <img
                    src="https://images.insighthealth.ai/office-practicum/logo.svg"
                    alt="Office Practicum Logo"
                    width={20}
                    height={20}
                    className="mr-[-4px]"
                  />
                ),
              },
            ]
          : []),
        ...(isOpenDrHqAccount && isOpenDrHqSuperAdmin
          ? [
              {
                path: '/open-dr-settings',
                title: 'OpenDr Admin',
                icon: <SettingOutlined />,
              },
            ]
          : []),
      ],
    },
  ];

  if (hasTagAccess) {
    settingsMenus[0].submenu.push({
      path: '/settings/tags',
      title: 'Tags',
      icon: <TagsOutlined />,
    });
  }

  return settingsMenus;
};
